<div class="device-selector-dialog">
  <!-- Header -->
  <div class="dialog-header">
    <h2 mat-dialog-title>Cast to Device</h2>
    <button mat-icon-button 
            matTooltip="Refresh devices"
            (click)="refreshDevices()"
            class="refresh-button">
      <mat-icon>refresh</mat-icon>
    </button>
    <button mat-icon-button 
            matTooltip="Close"
            (click)="closeDialog()"
            class="close-button">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Loading State -->
  <div *ngIf="isLoading" class="loading-container">
    <mat-spinner [diameter]="40"></mat-spinner>
    <p>Finding devices...</p>
  </div>

  <!-- Device List -->
  <div *ngIf="!isLoading" class="device-list">
    <!-- Current Device -->
    <div *ngIf="currentDevice || currentCastDevice" class="current-device-section">
      <h3 class="section-title">Currently playing on</h3>
      
      <!-- Spotify Device -->
      <div *ngIf="currentDevice" class="device-item current-device">
        <div class="device-icon">
          <mat-icon>{{ getDeviceIcon(currentDevice.type) }}</mat-icon>
        </div>
        <div class="device-info">
          <div class="device-name">{{ currentDevice.name }}</div>
          <div class="device-type">{{ getDeviceTypeLabel(currentDevice.type) }}</div>
        </div>
        <div class="device-status">
          <mat-icon class="active-icon">volume_up</mat-icon>
          <span class="active-text">Active</span>
        </div>
      </div>

      <!-- Cast Device -->
      <div *ngIf="currentCastDevice" class="device-item current-device">
        <div class="device-icon">
          <mat-icon>{{ getDeviceIcon(currentCastDevice.type) }}</mat-icon>
        </div>
        <div class="device-info">
          <div class="device-name">{{ currentCastDevice.name }}</div>
          <div class="device-type">{{ getDeviceTypeLabel(currentCastDevice.type) }}</div>
        </div>
        <div class="device-status">
          <mat-icon class="active-icon">volume_up</mat-icon>
          <span class="active-text">Connected</span>
          <button mat-icon-button 
                  matTooltip="Disconnect"
                  (click)="disconnectCast()"
                  class="disconnect-button">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>
    </div>

    <!-- Available Devices -->
    <div class="available-devices-section">
      <h3 class="section-title">Available devices</h3>

      <!-- Cast to nearby device option -->
      <div *ngIf="showCastOption()" 
           class="device-item available-device cast-device"
           (click)="selectCastDevice()">
        <div class="device-icon">
          <mat-icon>cast</mat-icon>
        </div>
        <div class="device-info">
          <div class="device-name">Cast preview to device</div>
          <div class="device-type">30-second track previews</div>
        </div>
        <div class="device-status">
          <mat-icon class="cast-icon">wifi</mat-icon>
        </div>
      </div>

      <!-- Tab mirroring option -->
      <div *ngIf="isCastAvailable && castService.supportsTabMirroring()" 
           class="device-item available-device mirror-device"
           (click)="castTabAudio()">
        <div class="device-icon">
          <mat-icon>tab</mat-icon>
        </div>
        <div class="device-info">
          <div class="device-name">Mirror tab audio</div>
          <div class="device-type">Full tracks via Chrome tab casting</div>
        </div>
        <div class="device-status">
          <mat-icon class="mirror-icon">screen_share</mat-icon>
        </div>
      </div>
      
      <div *ngIf="hasNoOtherDevices()" class="no-devices">
        <mat-icon>speaker_notes_off</mat-icon>
        <p>No other devices found</p>
        <small>Make sure Spotify is open on other devices</small>
      </div>

      <div *ngFor="let device of getAvailableDevices()" 
           class="device-item available-device"
           (click)="selectDevice(device)">
        <div class="device-icon">
          <mat-icon>{{ getDeviceIcon(device.type) }}</mat-icon>
        </div>
        <div class="device-info">
          <div class="device-name">{{ device.name }}</div>
          <div class="device-type">{{ getDeviceTypeLabel(device.type) }}</div>
        </div>
        <div class="device-status">
          <mat-icon class="volume-icon" 
                    [class.muted]="device.volume_percent === 0">
            {{ device.volume_percent === 0 ? 'volume_off' : 'volume_up' }}
          </mat-icon>
          <span class="volume-text">{{ device.volume_percent }}%</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Footer Info -->
  <div *ngIf="!isLoading" class="dialog-footer">
    <small class="help-text">
      <mat-icon>info</mat-icon>
      Devices refresh automatically. Open Spotify on other devices to see them here.
    </small>
    <small *ngIf="isCastAvailable" class="cast-info">
      <mat-icon>cast</mat-icon>
      Cast previews (30s clips) or mirror tab audio (full tracks) to Chromecast devices.
    </small>
    <details *ngIf="isCastAvailable" class="troubleshooting">
      <summary>🔧 No audio when casting? Click here for help</summary>
      <div class="troubleshooting-content">
        <p><strong>Tab casting troubleshooting:</strong></p>
        <ul>
          <li>✅ Make sure to check "Share audio" when casting</li>
          <li>✅ Check Chromecast device volume</li>
          <li>✅ Ensure browser tab isn't muted</li>
          <li>✅ Try casting entire screen instead of just tab</li>
          <li>✅ Close and reopen Spotify if audio stops working</li>
        </ul>
        <p><strong>Alternative:</strong> Use a Spotify Connect device (other phone/computer with Spotify) for most reliable full-track playback.</p>
      </div>
    </details>
  </div>
</div>